import { motion, useInView, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ArrowRight } from "lucide-react";

const PROMO_IMAGE = "https://customer-assets.emergentagent.com/job_minimal-arquitectos/artifacts/7ejno9yy_image.png";

export default function CTABanner() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], [-30, 30]);

  return (
    <section ref={ref} className="relative h-[40vh] md:h-[45vh] overflow-hidden" data-testid="cta-banner">
      {/* BG image — cropped to top portion (house only) */}
      <motion.div className="absolute inset-0" style={{ y: imgY }}>
        <img
          src={PROMO_IMAGE}
          alt="Merza Soluciones"
          className="w-full h-[140%] object-cover object-top"
        />
        {/* Heavy overlay to hide baked-in text */}
        <div className="absolute inset-0 bg-black/75" />
      </motion.div>

      {/* Content */}
      <div className="relative z-10 h-full flex items-center px-6 md:px-12 lg:px-24 max-w-[1800px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col md:flex-row md:items-center md:justify-between w-full gap-6"
        >
          <div>
            <p className="text-white/40 text-[11px] tracking-[0.3em] uppercase mb-3">
              Merza Soluciones
            </p>
            <h2
              className="text-2xl md:text-3xl lg:text-4xl font-medium text-white tracking-tight leading-[1.15]"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              Tu proyecto en las <span className="text-white/40">mejores manos</span>
            </h2>
          </div>
          <motion.button
            initial={{ opacity: 0 }}
            animate={inView ? { opacity: 1 } : {}}
            transition={{ delay: 0.4 }}
            onClick={() => document.querySelector("#contacto")?.scrollIntoView({ behavior: "smooth" })}
            className="group inline-flex items-center gap-3 bg-white text-black px-8 py-4 rounded-full text-sm font-medium hover:shadow-[0_10px_40px_rgba(255,255,255,0.15)] transition-all duration-500 active:scale-[0.97] w-fit flex-shrink-0"
            data-testid="cta-banner-button"
          >
            Agenda tu cita
            <ArrowRight size={16} strokeWidth={2} className="group-hover:translate-x-1 transition-transform" />
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
}
